
// represents a fake ipfs hash for something that has not been uploaded yet
export const NOT_UPLOADED_YET = 'NOT_UPLOADED_YET';
